import type { Distance, Margins, SpatialRectangle } from "@pdfking/math"
import { Center, Min, Scale } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import { Oval, PlotFunction } from "@pdfking/renderer-api"
import type { Atom, StringGUID } from "@pdfking/tfunc"

import { PALETTE } from "#constants"

import { DrawBackpackGrid } from "../pattern/DrawBackpackGrid"
import { CreateRandom } from "../random/CreateRandom"

/** Where a calendar's picture goes, `box`, running on into `bleed`: a
 * backpack grid of its own for `salt`, standing for the customer's picture,
 * the pantone and the UV printing its ground round its tiles. A `round` one is a disc
 * in the secondary. What is set `over` it, over it, the tiles clear of it. */
export const CalendarImage = ({
  bleed,
  box,
  over,
  round,
  salt,
  seed,
  short,
}: {
  bleed: Margins<Distance>
  box: SpatialRectangle<Distance>
  over: PageShape[]
  round: boolean
  salt: Atom
  seed: StringGUID
  short: Distance
}): PageShape[] =>
  round
    ? [
        {
          closed: true,
          enum: PlotFunction.PLOT_PATH,
          fill_color: PALETTE.secondary,
          points: Oval(Center(box), Scale(Min(box.width, box.height), 0.5)),
        },
        ...over,
      ]
    : DrawBackpackGrid({
        bleed,
        box,
        over,
        random: CreateRandom(seed, "calendar picture", salt),
        short,
      })
